module.exports = __webpack_public_path__ + "img/chat_pdf.11d3397f.svg";